<template>
  <v-sheet class="search-panel" outlined>
    <div class="search-panel__content">
      <v-text-field
        ref="searchField"
        v-model="searchParam"
        class="search-field"
        hide-details
        outlined
        dense
        prepend-inner-icon="mdi-magnify"
        single-line
        autocomplete="off"
        :placeholder="label"
        @keyup.enter="search"
      ></v-text-field>
      <v-btn class="search-btn" type="button" color="success" depressed @click="search">
        <v-icon left small>mdi-magnify</v-icon>
        Search
      </v-btn>
    </div>
  </v-sheet>
</template>

<script>
export default {
  name: 'SearchBar',
  props: ['label', 'clearOnSearch', 'defaultValue'],
  data() {
    return {
      searchParam: this.defaultValue || "",
    };
  },
  watch: {
    defaultValue(newValue) {
      this.searchParam = newValue;
    },
  },
  methods: {
    search: function() {
      this.$emit('search', this.searchParam);
      if (this.clearOnSearch != null && this.clearOnSearch) {
        this.searchParam = "";
      }
    },

    setSearch: function(search) {
      this.searchParam = search;
    },

    focus: function() {
      if (this.$refs.searchField) {
        this.$refs.searchField.focus();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-panel {
  background: #ffffff !important;
  border: 1px solid #dfe7ef !important;
  border-radius: 8px !important;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  padding: 12px;
  width: 100%;
}

.search-panel__content {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr;
}

.search-btn {
  width: 100%;
}

@media (min-width: 640px) {
  .search-panel__content {
    align-items: center;
    grid-template-columns: minmax(0, 1fr) auto;
  }

  .search-btn {
    min-width: 120px;
    width: auto;
  }
}
</style>
